

<router-outlet></router-outlet>

